import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { Creators as NotificationActions } from "store/ducks/notification";

import { Button } from "libs/purple-ui";
import Footer from "components/Footer";

import Logo from "assets/imgs/brand/closeer-logo.svg";

import * as S from "./styles";

const NotFound = ({ external = false }) => {
  const { t } = useTranslation(["not_found"]);
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();

  const path_to_redirect = useSelector((state) => {
    let bigcompany = state?.auth?.tokenAdministrator;
    let spv = state?.auth?.tokenSupervisor;
    let establishment = state?.auth?.tokenManager;

    let root_path = "/login";

    if (pathname.startsWith("/adm") || !!bigcompany) {
      root_path = "/adm";
    } else if (pathname.startsWith("/spv") || !!spv) {
      root_path = "/spv";
    } else if (pathname.startsWith("/dashboard") || !!establishment) {
      root_path = "/dashboard";
    }

    return root_path;
  });

  useEffect(() => {
    dispatch(NotificationActions.trigger(t("warning_message"), "warning"));
  }, []);

  const handleGoBack = () => {
    history.replace({
      pathname: path_to_redirect,
    });
  };

  return (
    <S.Container external={external}>
      <S.Content>
        {external && <S.Logo src={Logo} alt="Closeer Brand" />}
        <S.Header>
          <h1>{t("title")}</h1>
          <h3>{t("page_not_found")}</h3>
        </S.Header>
        <S.Illustration src="/404-error.svg" alt="404 Not Found" />
        {external && <Button onClick={handleGoBack}>{t("goback")}</Button>}
      </S.Content>
      {external && <Footer />}
    </S.Container>
  );
};

export default NotFound;
